var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',[_c('vs-tab',{attrs:{"label":"발매신청 관리"}},[_c('applicationComponent')],1),_c('vs-tab',{attrs:{"label":"캘린더"}},[_c('calendarComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }